import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import UsersService from "../../../../../../../services/users.service";
import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { TQuickAnswerForm } from "../QuickAnswerSchema";
import { useWatch } from "react-hook-form";

const usersService = new UsersService();

const translationPath = "page.settings.quickAnswer.";

export const UserSelector = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext<TQuickAnswerForm>();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const currentShareType = useWatch({ name: "shareType", control });

  const { sendRequest } = useFetch(usersService.listTicketUsers);

  const fetchUsers = useCallback(async () => {
    const { data, success } = await sendRequest(null);

    if (data && success) {
      setOptions(data);
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  if (!currentShareType || currentShareType.code !== "1") return null;

  return (
    <Grid item xs={12} md={6}>
      <AutoComplete
        name="user"
        label={t(translationPath + "user")}
        size="small"
        options={options}
        getOptionLabel={(option) => option.name}
      />
    </Grid>
  );
});
